"use client"
import { MdOutlineWbSunny } from "react-icons/md";
import { FiMoon } from "react-icons/fi";
import { darkMode } from "@/store/darkMode/darkMode-store";

export const ButtonDarkMode = () => {
    const { isDark, toggleDarkMode } = darkMode();

    return (
        <button onClick={toggleDarkMode} className="p-2 rounded-md hover:bg-blue-cole-soft dark:hover:bg-blue-cole-dark-surface border dark:border-gray-dark">
            {
                isDark ? <FiMoon size={20} className="dark:text-ink-muted-dark" /> : <MdOutlineWbSunny size={20} className="text-black" />
            }
        </button>
    )
}
